import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="py-12 px-6 md:px-12 bg-[#0D0D0D] border-t border-[#262626]">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-white font-heading text-xl tracking-wider">
                CAN<span className="text-[#F5A623]">GGU</span>
              </span>
              <span className="text-gray-400 text-sm font-light">PODCAST</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Premium podcast and video recording studio in Canggu, Bali. 
              Professional equipment, cinematic quality, ready-to-record environment.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/canggupodcast"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#262626] hover:border-[#F5A623] hover:text-[#F5A623] transition-colors text-gray-400"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://wa.me/6281339750577"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#262626] hover:border-[#F5A623] hover:text-[#F5A623] transition-colors text-gray-400"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white text-sm tracking-wider mb-4">QUICK LINKS</h4>
            <nav className="space-y-2">
              <a href="/#services" className="block text-gray-400 hover:text-[#F5A623] text-sm transition-colors">Services</a>
              <a href="/#rooms" className="block text-gray-400 hover:text-[#F5A623] text-sm transition-colors">Rooms</a>
              <a href="/#pricing" className="block text-gray-400 hover:text-[#F5A623] text-sm transition-colors">Pricing</a>
              <Link to="/booking" className="block text-gray-400 hover:text-[#F5A623] text-sm transition-colors">Book Now</Link>
              <Link to="/custom-payment" className="block text-gray-400 hover:text-[#F5A623] text-sm transition-colors">Custom Payment</Link>
            </nav>
          </div>

          {/* Location */}
          <div>
            <h4 className="font-heading text-white text-sm tracking-wider mb-4">LOCATION</h4>
            <a
              href="https://maps.app.goo.gl/vHmbGBRy8tnMXPNf7"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-2 text-gray-400 hover:text-[#F5A623] transition-colors text-sm"
            >
              <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
              <span>
                Jl. Pantai Berawa No.150,<br />
                Canggu, Tibubeneng,<br />
                Kabupaten Badung,<br />
                Bali 80361
              </span>
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-[#262626] flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <p className="text-gray-500 text-sm">
            © 2026 Canggu Podcast Studio. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            All transactions are made in Indonesian Rupiah (IDR) only.
          </p>
        </div>
      </div>
    </footer>
  );
};
